import React from "react";
import {ApiResponse} from './axios';
import {FormattedMessage} from 'react-intl';
import {VideoContent} from "./video-content";
import {PersonRole} from "./person-role";
import {Person} from "./person";

export const enum DraftPeopleStatus {
    "PENDING" = "pending",
    "APPROVED" = "approved",
    "REJECTED" = "rejected",
}

export interface DraftPeople extends ApiResponse {
    id: string;
    status: DraftPeopleStatus;
    video_content:VideoContent[];
    person_role:PersonRole[];
    person:Person[];
    created_at: any;
}

export interface DraftPeopleState {
    readonly loading: boolean
    readonly data: DraftPeople[]
    readonly errors?: string
    readonly count: number
}

export const DraftPeopleStatusOptions = [{
    value: DraftPeopleStatus.PENDING,
    label: <FormattedMessage id="app.pending" defaultMessage={`Pending`}/>
}, {
    value: DraftPeopleStatus.APPROVED,
    label: <FormattedMessage id="app.approved" defaultMessage={`Approved`}/>
}, {
    value: DraftPeopleStatus.REJECTED,
    label: <FormattedMessage id="app.rejected" defaultMessage={`Rejected`}/>
}];

